import { render, staticRenderFns } from "./SectionsPageConfig.vue?vue&type=template&id=701176a1&scoped=true&"
import script from "./SectionsPageConfig.vue?vue&type=script&lang=js&"
export * from "./SectionsPageConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701176a1",
  null
  
)

export default component.exports